export const constHeaders = {
  0: [
    "", // strzałka
    "Baza",
    "Liczba kalibracji",
    "500 Hz",
    "1000 Hz",
    "2000 Hz",
    "4000 Hz",
    "Notatki", // NOWA KOLUMNA
  ],
  1: [
    "",
    "Producent",
    "Liczba kalibracji",
    "500 Hz",
    "1000 Hz",
    "2000 Hz",
    "4000 Hz",
    "Notatki",
  ],
  2: [
    "",
    "Marka",
    "Liczba kalibracji",
    "500 Hz",
    "1000 Hz",
    "2000 Hz",
    "4000 Hz",
    "Notatki",
  ],
  3: [
    "",
    "Producent",
    "Model",
    "Liczba kalibracji",
    "500 Hz",
    "1000 Hz",
    "2000 Hz",
    "4000 Hz",
    "Notatki",
    "Odsłuchy",
  ],
};

export function getAveragedHeaders(option, isDetailedData) {
  const headers = constHeaders[option] || [];

  if (!isDetailedData) {
    return headers;
  }

  if (Number(option) !== 3) {
    const indexAfterCount =
      headers.findIndex((header) => header === "Liczba kalibracji") + 1;

    return indexAfterCount === 0
      ? headers
      : [
          ...headers.slice(0, indexAfterCount),
          "",
          ...headers.slice(indexAfterCount),
        ];
  }

  const indexAfterLastFrequency =
    headers.findIndex((header) => header === "4000 Hz") + 1;

  if (indexAfterLastFrequency === 0) {
    return headers;
  }

  return [
    ...headers.slice(0, indexAfterLastFrequency),
    "8000 Hz",
    "16000 Hz",
    ...headers.slice(indexAfterLastFrequency),
  ];
}
